

export const frontMatter = {
	authors: [
		'noomorph',
		'jvs'
	]
};
export const contentTitle = 'Asimetrija medžu LJ/NJ i Љ/Њ';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-blog/default/site-articles-2024-07-09-diskusija-lj-nj-md-1a9.json'
export const assets = {
"authorsImageUrls": [undefined, undefined],
};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Motivacija",
  "id": "motivacija",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "motivacija",
      children: "Motivacija"
    }), "\n", _jsxs(_components.p, {
      children: ["Už několiko sedmic Jan van Steenbergen jest mnogo zajety s prěvodženjem viki-interfejsa, da byhmo mogli potom spokojno početi rabotu nad MS Vikipedijeju. To jest spěšno dělo, ibo kratko poslě publikacije našego koda ", _jsx(_components.code, {
        children: "ISO 639-3"
      }), " uže pojavilo se prědloženje za MS Vikipediju MS projekt v Inkubatoru. Ne hočemo, aby ljudi počeli kopijovati teksty iz Medžuviki, čto jest narušenje avtorskyh prav. Vměsto togo, trěba bude kopirati cělo sodržanje Medžuviki v Inkubator – zajedno s historijeju. V Medžuviki jest avtomatičny transliterator, da by čitatelji mogli izbirati medžu latiniceju i kiriliceju. Očevidno, v Vikipediji on takože bude potrěbny. Tu jest jedin maly problem."]
    }), "\n", _jsxs(_components.p, {
      children: ["Tutdenj medžuslovjansky pravopis imaje asimetriju medžu latiniceju i kiriliceju, čto se tyče prědavanja digrafov ", _jsx(_components.code, {
        children: "lj"
      }), " i ", _jsx(_components.code, {
        children: "nj"
      }), " na pismu, i to jest objekt našej diskusije niže."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

